<template>
  <div :class="props.className">
    <slot name="scroll-list"></slot>
    <p v-show="!hideBottomText" :id="props.id" class="scroll-bottom-tips">{{ loadMoreText }}</p>
  </div>
</template>

<script setup lang="tsx">
  import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';

  const props = withDefaults(
    defineProps<{
      // 滚动容器样式
      className: string;
      // 列表数据
      data: TLooseObj[];
      // 记录总条数
      total: number;
      // 每页数量
      pageSize?: number;
      // 是否加载到底部判断元素id--页面只有一个滚动容器时不用传
      id?: string;
      // 是否隐藏底部文案
      hideBottomText?: boolean;
    }>(),
    {
      total: 0,
      pageSize: 10,
      className: '',
      id: 'load-more-component',
      hideBottomText: false,
    }
  );

  // 滚动到底部判断元素
  const scrollBottomEle = ref<HTMLElement>();
  // 滚动到底观察器
  const intersectionObserver = ref();
  const dataLoadEnd = ref(true);
  // console.log('init');
  // 数据还未加载完
  const loadMoreText = computed(() => {
    const { total = 0, data = [] } = props;
    // 数据数量小于6条,不显示已经加载到底文案
    if (data.length < 6) {
      return ' ';
    } else if (data.length >= total) {
      return '已经到底了';
    }

    return '加载中...';
  });

  // 监听列表数据长度变化,列表长度有变化,说明前一次滚动到底的数据已加载完
  watch(
    () => props.data.length,
    () => {
      // 过滤掉每次切换导航，空数组引起的数据变更干扰
      if (props.data.length) {
        // console.log('data-change > 0', props.data);
        // 标记前一次滚动到底派发事件数据已加载
        dataLoadEnd.value = true;
      }
    }
  );

  onMounted(() => {
    // 监听滚动到底事件
    listenerScrollBottom();
  });

  onBeforeUnmount(() => {
    // 组件销毁前,关闭观察器
    closeObserver();
  });

  const listenerScrollBottom = () => {
    // console.log('listenerScrollBottom', props.className, scrollBoxEle.value);
    // 获取滚动到底的判断元素
    scrollBottomEle.value = document.querySelector(`#${props.id}`) as HTMLElement;
    // console.log(scrollBottomEle.value);

    if (scrollBottomEle.value) {
      intersectionObserver.value = new IntersectionObserver((entries) => {
        // console.log(entries[0]);
        // 如果不可见，就返回
        if (entries[0].intersectionRatio <= 0) return;
        // 触发加载更多--加dataLoadEnd判断条件,防止滚动到底事件被高频触发
        // dataLoadEnd--前一次滚动到底的数据已加载完
        if (dataLoadEnd.value && props.data.length < props.total) {
          // 重置标记位,标记当前滚动到底派发事件的数据还未加载
          dataLoadEnd.value = false;
          triggerLoadMore();
        }
      });
      // 开始观察
      intersectionObserver.value.observe(scrollBottomEle.value);
    }
  };

  // 关闭观察器
  const closeObserver = () => {
    // 如果被观察元素不存在,则中断
    if (!scrollBottomEle.value) return;
    // 停止观察
    intersectionObserver.value?.unobserve(scrollBottomEle.value);
    // 关闭滚动监听观察器
    intersectionObserver.value?.disconnect();
  };

  // 向外传递滚动到底事件
  const emit = defineEmits(['loadMore']);
  const triggerLoadMore = () => {
    emit('loadMore');
  };
</script>
<style lang="less" scoped>
  // 底部提示
  .scroll-bottom-tips {
    height: 0.8rem;
    line-height: 0.8rem;
    font-family: PingFangSC-Regular, 'PingFang SC';
    font-size: 0.22rem;
    font-weight: 400;
    color: #999;
    text-align: center;
    background-color: transparent;
  }
</style>
